module.exports = __webpack_public_path__ + "4dbf54251966b2a42adec647c47ac51b.png";